module.exports = __webpack_public_path__ + "static/media/clementines.4eb29084.svg";